// datepicker-i18n.service.ts
import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { NgbTimepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TimepickerI18nService extends NgbTimepickerI18n {

  private timeEn = ['AM', 'PM'];
  private timeAr = ['ص', 'م'];
  isArabic: boolean;
  constructor(@Inject(LOCALE_ID) private locale: string, private translateService: TranslateService) {
    super();
    this.isArabic = this.translateService.getDefaultLang() == 'en' ? false : true;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      if (res) {
        this.isArabic = res.lang == 'en' ? false : true;
      }
    });
  }
  override getMorningPeriod(): string {
    return this.isArabic ? this.timeAr[0] : this.timeEn[0];

  }
  override getAfternoonPeriod(): string {
    return this.isArabic ? this.timeAr[1] : this.timeEn[1];

  }
}
